import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    offerHome: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: 1320,
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            margin: "0 auto",
            alignItems: "flex-start",
            flexDirection: "row",
            minHeight: 540,
            paddingLeft: theme.spacing(5),
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            alignItems: "flex-start",
        },
    },
    offerHomeContent: {
        width: "50%",
        paddingTop: theme.spacing(5),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
        },
    },
    offerHomeImage: {
        width: "50%",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            display: "flex",
            justifyContent: "center",
            width: "100%",
        },
    },
    desktopImage: {
        objectFit: "cover",
        height: 560,
    },
    mobileImage: {
        width: "100%",
    },
}));
